var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1142_23112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3346 14V12.6667C11.3346 11.9594 11.0537 11.2811 10.5536 10.781C10.0535 10.281 9.37521 10 8.66797 10H3.33464C2.62739 10 1.94911 10.281 1.44902 10.781C0.94892 11.2811 0.667969 11.9594 0.667969 12.6667V14M15.3346 14V12.6667C15.3342 12.0758 15.1375 11.5018 14.7755 11.0349C14.4136 10.5679 13.9067 10.2344 13.3346 10.0867M10.668 2.08667C11.2416 2.23353 11.75 2.56713 12.1131 3.03487C12.4761 3.50261 12.6732 4.07789 12.6732 4.67C12.6732 5.26211 12.4761 5.83739 12.1131 6.30513C11.75 6.77287 11.2416 7.10647 10.668 7.25333M8.66797 4.66667C8.66797 6.13943 7.47406 7.33333 6.0013 7.33333C4.52854 7.33333 3.33464 6.13943 3.33464 4.66667C3.33464 3.19391 4.52854 2 6.0013 2C7.47406 2 8.66797 3.19391 8.66797 4.66667Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1142_23112"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/Users.1d17a7dfe39b8ce626e5a2a02e27e1cb.svg";
export { ForwardRef as ReactComponent };